import { render } from "./WizardSteps.vue?vue&type=template&id=352b7ae8&scoped=true"
import script from "./WizardSteps.vue?vue&type=script&lang=js"
export * from "./WizardSteps.vue?vue&type=script&lang=js"

import "./WizardSteps.vue?vue&type=style&index=0&id=352b7ae8&scoped=true&lang=css"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352b7ae8"]])

export default __exports__